import axios from 'axios';
import { IS_CLIENT_SIDE } from '@dr.pogodin/react-utils';

import type { GetAggregatedUserScoresResT } from 'server/controllers/user-scores';
import { E_SCORES, P_API_USERS } from 'utils';

export async function getAggregatedUserScores(
  userId: string,
): Promise<GetAggregatedUserScoresResT> {
  if (!IS_CLIENT_SIDE) return null as unknown as GetAggregatedUserScoresResT;

  const res = await axios<GetAggregatedUserScoresResT>(
    `${P_API_USERS}/${userId}${E_SCORES}/aggregated`,
  );

  return res.data;
}
